import { Component, HostBinding, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { RowClassArgs } from '@progress/kendo-angular-grid';
import { AccountConfigService } from '../../../services/account-config/account-config.service';
import { SessionService } from '../../../services/session/session.service';
import { MSession } from '@argalis-apps/models';
import { AuthService } from './../../../../auth/services/auth/auth.service';
import { tableAddIcon, SVGIcon } from '@progress/kendo-svg-icons';
import Swal from 'sweetalert2';
import * as moment from 'moment';

@Component({
  selector: 'ags-session-planning',
  templateUrl: './session-planning.component.html',
  styleUrls: ['./session-planning.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SessionPlanningComponent implements OnInit {
  @HostBinding('class') themeFlag: string;
  public svgTableAdd: SVGIcon = tableAddIcon;
  private userId: number;
  public bOst: boolean;
  public gridData: any;
  public idSession;
  public dateTranche: any;
  public typeTranche = null;
  public heureDebutTranche: any;
  public heureFinTranche: any;
  public listItems: Array<{ id: number; type: string }> = [{ id: 1, type: 'matin' }, { id: 2, type: 'après-midi' }];
  public listSites: Array<any>;
  public site = null;
  public idTranche = null;
  public listIntervenant = null;
  gestionTranchesIntervenant = { b_actif: false };
  public ajoutTranche = null;
  public dialogOpened = false;
  @Input('idSession')
  set _idSession(value: string) {
    if (value) {
      this.idSession = value;
    }
  }

  constructor(
    private accountConfigService: AccountConfigService,
    private sessionService: SessionService,
    private authService: AuthService
  ) {
    this.userId = this.authService.userConnected.userInfo.id;
    this.bOst = this.authService.userConnected.userInfo.b_ost;
  }

  shade(context: RowClassArgs) {
    const isEven = !(context.dataItem as MSession.IPlanning).intertranche;
    return {
      grisement: isEven,
      odd: !isEven
    };
  }

  async ngOnInit() {
    this.ajoutTranche = { autorise: null };
    this.sessionService.moducleChecker('EXTRANET_INTERVENANT_GESTION_TRANCHES').subscribe(data => {
      this.gestionTranchesIntervenant = data[0];
      if (this.gestionTranchesIntervenant.b_actif) {
        this.verifAjoutTranche();
      }
    });
    this.gridData = this.sessionService.getPlanningBySession(this.idSession, this.userId, this.bOst);
    this.themeFlag = `${this.themeFlag || ''} ${this.accountConfigService.themingClassName}`;
    this.sessionService.getClientSite(this.idSession).subscribe(sites => {
      this.listSites = sites
    });
  }

  verifAjoutTranche() {
    this.sessionService.verifAJoutTranche(this.idSession).subscribe(data => (this.ajoutTranche = data));
  }

  loadDefaultHours(momentJournee: any) {
    if (momentJournee.id === 1) {
      this.heureDebutTranche = moment()
        .local()
        .toDate();
      this.heureDebutTranche.setHours(9, 0, 0);
      this.heureFinTranche = moment()
        .local()
        .toDate();
      this.heureFinTranche.setHours(12, 0, 0);
      this.typeTranche = this.listItems.find(type => Number(type.id) === Number(momentJournee.id));
    } else if (momentJournee.id === 2) {
      this.heureDebutTranche = moment()
        .local()
        .toDate();
      this.heureDebutTranche.setHours(14, 0, 0);
      this.heureFinTranche = moment()
        .local()
        .toDate();
      this.heureFinTranche.setHours(18, 0, 0);
      this.typeTranche = this.listItems.find(type => Number(type.id) === Number(momentJournee.id));
    }
  }

  cellClickHandler({ dataItem }) {
    const date = dataItem.date_session.split('/');
    const heureDeb = dataItem.heuredebut.split(':');
    const heureFin = dataItem.heurefin.split(':');
    const dateString = date[1] + '/' + date[0] + '/' + date[2];

    if (
      moment(`${dateString} ${heureDeb[0]}:${heureDeb[1]}:${heureDeb[2]}`)
        .local()
        .toDate() < new Date()
    ) {
      Swal.fire({
        timer: 2000,
        text: 'Impossible de modifier ou supprimer une tranche dont la date est passée.',
        icon: 'error',
        customClass: {
          popup: 'swal-modal'
        },
        showConfirmButton: false,
        showCancelButton: false,
      });
      return;
    } else if (dataItem.b_export_cegid) {
      Swal.fire({
        timer: 2000,
        text: 'Impossible de modifier ou supprimer une tranche déjà exportée.',
        icon: 'error',
        customClass: {
          popup: 'swal-modal'
        },
        showConfirmButton: false,
        showCancelButton: false,
      });
      return;
    }

    const idInterv = [];
    for (const id of dataItem.id_intervenant) {
      if (Number(id) !== Number(this.userId)) {
        idInterv.push(id);
      }
    }

    if (
      idInterv.length > 1 ||
      (idInterv.length === 1 && Number(idInterv[0]) !== Number(this.userId) && idInterv[0] !== null)
    ) {
      Swal.fire({
        timer: 2000,
        text: 'Impossible de modifier ou supprimer une tranche avec un autre intervenant.',
        icon: 'error',
        customClass: {
          popup: 'swal-modal'
        },
        showConfirmButton: false,
        showCancelButton: false,
      });
      return;
    }

    document.getElementById('open-modal-tranche').click();
    this.heureFinTranche = moment(`2021-01-01 ${heureFin[0]}:${heureFin[1]}:${heureFin[2]}`, 'YYYY-MM-DD HH:mm:SS')
      .local()
      .toDate();
    this.dateTranche = moment(dateString)
      .local()
      .toDate();
    this.heureDebutTranche = moment(`2021-01-01 ${heureDeb[0]}:${heureDeb[1]}:${heureDeb[2]}`, 'YYYY-MM-DD HH:mm:SS')
      .local()
      .toDate();
    this.site = this.listSites.find(site => site.libelle === dataItem.site);
    this.typeTranche = this.listItems.find(type => Number(dataItem.id_moment_journee) === Number(type.id));
    this.idTranche = dataItem.sp_id;

    this.heureFinTranche =
      this.heureFinTranche instanceof Date && !isNaN(this.heureFinTranche.valueOf()) ? this.heureFinTranche : '';
    this.dateTranche = this.dateTranche instanceof Date && !isNaN(this.dateTranche.valueOf()) ? this.dateTranche : '';
    this.heureDebutTranche =
      this.heureDebutTranche instanceof Date && !isNaN(this.heureDebutTranche.valueOf()) ? this.heureDebutTranche : '';
  }

  deleteTranche({ dataItem }) {
    if (
      dataItem.id_intervenant.length > 1 ||
      (dataItem.id_intervenant.length === 1 &&
        Number(dataItem.id_intervenant[0]) !== Number(this.userId) &&
        dataItem.id_intervenant[0] !== null)
    ) {
      Swal.fire({
        timer: 2000,
        text: 'Impossible de modifier ou supprimer une tranche avec un autre intervenant.',
        icon: 'error',
        customClass: {
          popup: 'swal-modal'
        },
        showConfirmButton: false,
        showCancelButton: false,
      });
      return;
    } else if (dataItem.b_export_cegid) {
      Swal.fire({
        timer: 2000,
        text: 'Impossible de modifier ou supprimer une tranche déjà exportée.',
        icon: 'error',
        customClass: {
          popup: 'swal-modal'
        },
        showConfirmButton: false,
        showCancelButton: false,
      });
      return;
    }
    this.sessionService.deleteTranche(dataItem.sp_id, this.userId).subscribe(() => this.verifAjoutTranche());
    Swal.fire({
      timer: 2000,
      text: 'Tranche supprimées.',
      icon: 'success',
      customClass: {
        popup: 'swal-modal'
      },
      showConfirmButton: false,
      showCancelButton: false,
    });
    this.gridData = this.sessionService.getPlanningBySession(this.idSession, this.userId, this.bOst);
  }

  showAlert() {
    Swal.fire({
      timer: 3000,
      text: 'Tous les champs doivent être renseignés.',
      icon: 'error',
      title: 'Donnée(s) manquante(s)',
      customClass: {
        popup: 'swal-modal'
      },
      showConfirmButton: false,
      showCancelButton: false,
    });
  }

  resetData() {
    this.dateTranche = null;
    this.heureDebutTranche = null;
    this.heureFinTranche = null;
    this.typeTranche = null;
    this.site = null;
    this.idTranche = null;
    this.dialogOpened = true;
  }

  saveTranche(e) {
    const tranche = {
      date: moment(this.dateTranche)
        .local()
        .format('YYYY-MM-DD'),
      heureDebut: moment(this.heureDebutTranche)
        .local()
        .format('HH:mm'),
      heureFin: moment(this.heureFinTranche)
        .local()
        .format('HH:mm'),
      idIntervenant: this.userId,
      idSession: this.idSession,
      idMomentJournee: this.typeTranche,
      idSite: (this.site || {}).id,
      idTranche: this.idTranche || null
    };
    for (const key in tranche) {
      if (tranche.hasOwnProperty(key)) {
        if (!tranche[key] && key !== 'idTranche') {
          this.showAlert();
          return;
        }
      }
    }
    this.sessionService.saveTranche(tranche).subscribe(isSaved => {
      if (isSaved) {
        Swal.fire({
          timer: 2000,
          text: 'Données sauvegardées.',
          icon: 'success',
          customClass: {
            popup: 'swal-modal'
          },
          showConfirmButton: false,
          showCancelButton: false,
        });
        this.gridData = this.sessionService.getPlanningBySession(this.idSession, this.userId, this.bOst);
        this.verifAjoutTranche();
      } else {
        Swal.fire({
          timer: 2000,
          text: 'Une erreur s\'est produite lors de l\'enregistrement, merci de réessayer plus tard ou contactez le support.',
          icon: 'error',
          customClass: {
            popup: 'swal-modal'
          },
          showConfirmButton: false,
          showCancelButton: false,
        });
      }
    });
    this.dialogOpened = false;
  }
}
